/* istanbul ignore file */
import { array as codecArray, number as codecNumber } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
import { AutoTestSuite } from './AutoTestSuite';
const AutoTestSetParser = /* #__PURE__ */ parsers.object([
    ['id', codecNumber],
    ['suites', /* #__PURE__ */ codecArray(AutoTestSuite)],
    ['stopPoints', codecNumber, 'stop_points'],
]);
export class AutoTestSet extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return AutoTestSetParser.decode(input).map(res => new AutoTestSet(res));
    }
    static unsafeDecode(input) {
        return AutoTestSet.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return AutoTestSetParser.encode(data);
    }
    static schema() {
        return AutoTestSetParser.schema();
    }
}
